const MyButton = ({ text, type, onClick }) => {
  const btnType = ["positive", "negative"].includes(type) ? type : "default"; // type으로 이상한 값 전달되는 것 방지

  return (
    // <button className="MyButton" onClick={onClick} type={type}>
    <button
      className={["MyButton", `MyButton_${type}`].join(" ")}
      onClick={onClick}
      type={type}
    >
      {text}
    </button>
  );
};

MyButton.defaultProps = {
  type: "default",
};

export default MyButton;
